import React from "react";
import { 
    EditOutlined, 
    CreditCardOutlined
} from '@ant-design/icons';

import { FaFacebookF, FaYoutube } from "react-icons/fa";

import { 
  CircleQuestionMark, DollarSign, 
  GraduationCap, Headphones, 
  Heart, Settings,
  Users, Target,
  Trophy, Rocket,
  Award, Brain,
  ShoppingBag, Utensils,
  Ticket, Plane,
  FileText, ClipboardCheck,
  Briefcase, UserCheck,
  Send, ThumbsUp,
  CircleCheck,
  Coffee, Wifi,
  Shield, HardDrive,
  Monitor, Smartphone,
  Printer, TrendingUp,
  CreditCard, Package,
  Globe, Building2,
  Clock, Activity,
  Languages, 
  Phone, 
  Star, Lightbulb,
  Sparkle, 
  Sparkles, 
  Gift,
  Flame,Calendar,HelpCircle,
  User,
  CircleArrowRight,
  Bell,
  ArrowRight,
  LogOut,
  House
} from 'lucide-react';

export const USABLE_ICONS ={
  Activity: Activity,
  ArrowRight: ArrowRight,
  Award: Award, 
  Bell:Bell,
  Brain: Brain,
  Briefcase: Briefcase, 
  Building2: Building2,
  Calendar:Calendar,
  CircleArrowRight: CircleArrowRight,
  CircleCheck: CircleCheck,
  CircleQuestionMark: CircleQuestionMark,
  ClipboardCheck: ClipboardCheck,
  Clock: Clock,
  Coffee: Coffee,
  CreditCard: CreditCard, 
  CreditCardOutlined: CreditCardOutlined,
  DollarSign: DollarSign,
  EditOutlined: EditOutlined,
  Facebook: FaFacebookF,
  FileText: FileText,
  Flame:Flame,
  Gift: Gift,
  Globe: Globe, 
  GraduationCap: GraduationCap,
  HardDrive: HardDrive,
  Heart: Heart,
  Headphones: Headphones,
  HelpCircle:HelpCircle,
  House: House,
  Languages: Languages,
  Lightbulb: Lightbulb,
  LogOut: LogOut,
  Monitor: Monitor, 
  Package: Package,
  Phone: Phone,
  Plane: Plane, 
  Printer: Printer, 
  Rocket: Rocket,
  Send: Send, 
  Settings: Settings,
  Shield: Shield, 
  ShoppingBag: ShoppingBag, 
  Smartphone: Smartphone,
  Sparkle: Sparkle,
  Sparkles: Sparkles,
  Star: Star,
  Target: Target,
  ThumbsUp: ThumbsUp,
  Ticket: Ticket, 
  TrendingUp: TrendingUp,
  Trophy: Trophy,
  UserCheck: UserCheck,
  User: User,
  Users: Users,
  Utensils: Utensils,
  Wifi: Wifi,
  Youtube: FaYoutube,
}

export const displayIcon = (code, className="w-4 h-4 text-slate-600") => 
{
  if (!code) {
    return <HelpCircle className={className} />; // return a default icon
  }

  const Icon = USABLE_ICONS[code] || HelpCircle;
  return <Icon className={className}/>

};